import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Row, Col, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Spinner } from 'reactstrap';
import Translate, { t } from '../common/Translate';
import { useCalculation } from '../../hooks/usePricing/useCalculation';
import { Auth } from '../../config/configuration/react';
import { currencySign } from '../../Utils/currencySign';

const Calculation = ({ readOnly, toggle, coverage, permissionFord, originId }) => {
  const history = useHistory();

  const {
    purchaseAllow,
    setPurchaseAllow,
    maxMileageEntryStockDate,
    setMaxMileageEntryStockDate,
    counterAppraisalAllow,
    setCounterAppraisalAllow,
    buyerOffer,
    setBuyerOffer,
    buyerComment,
    setBuyerComment,
    handleCreate,
    isLoading,
    isError,
    openAutobizTradeLink,
    message,
    enableCounterAppraisal,
    enableManualDecision,
    recordStatus,
    recordCountryId,
  } = useCalculation();
  const { recordId } = useParams();
  const isNrmRecord = [10, 11, 12, 13, 14].includes(originId);
  const isNrmUser = Auth.isNrmUser();
  return (
    <>
      <Row className="mt-3">
        <Col>
          {isError === 'api_error_versions_quotation_unkown' && (
            <small className="info-text mb-3 text-center">
              <Translate code="api_error_versions_quotation_unkown" />
            </small>
          )}
          <Label for="authorizationToBuy" className="text-secondary text-uppercase font-weight-light text-left">
            {t('authorization_to_buy')}
          </Label>
          <Input
            type="select"
            className="rounded"
            id="authorizationToBuy"
            onChange={(e) => {
              if (e.target.value === 'N') setBuyerOffer('');
              setPurchaseAllow(e.target.value);
            }}
            value={purchaseAllow}
            disabled={readOnly}
          >
            <option key={0} value={0}>
              {t('select')}
            </option>
            <option key="Y" value="Y">
              {t('yes')}
            </option>
            <option key="N" value="N">
              {t('no')}
            </option>
          </Input>
        </Col>
      </Row>

      {purchaseAllow === 'Y' && recordCountryId === 7 && originId === 7 && (
        <Row className="mt-3">
          <Col>
            <Label for="maxMileageEntryStockDate" className="text-secondary text-uppercase font-weight-light text-left">
              {t('maxMileageEntryStockDate')}
            </Label>
            <InputGroup>
              <Input
                type="number"
                className={`input-currency input-currency-border ${!readOnly ? 'bg-white ' : ''}`}
                id="maxMileageEntryStockDate"
                placeholder={t('maxMileageEntryStockDate')}
                data-cy="maxMileageEntryStockDate"
                onChange={(e) => {
                  setMaxMileageEntryStockDate(e.target.value);
                }}
                value={maxMileageEntryStockDate}
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  className={`input-currency-border input-currency-label ${!readOnly ? 'bg-white ' : ''}`}
                >
                  {t('km')}
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Col>
        </Row>
      )}

      {enableCounterAppraisal && enableManualDecision && (
        <Row className="mt-3">
          <Col>
            <Label for="counterAppraisalRequired" className="text-secondary text-uppercase font-weight-light text-left">
              {t('counterAppraisalRequired')}
            </Label>
            <Input
              type="select"
              className="rounded"
              id="counterAppraisalRequired"
              onChange={(e) => {
                setCounterAppraisalAllow(e.target.value);
              }}
              value={counterAppraisalAllow}
              disabled={readOnly || recordStatus === 40}
              isRequired
            >
              <option key={0} value="">
                {t('select')}
              </option>
              <option key="Y" value={1}>
                {t('yes')}
              </option>
              <option key="N" value={0}>
                {t('no')}
              </option>
            </Input>
          </Col>
        </Row>
      )}

      <Row className="mt-3">
        <Col>
          <Label for="supervisorOffer" className="text-secondary text-uppercase font-weight-light text-left">
            {t('buyout_offer')}
          </Label>

          <InputGroup>
            <Input
              type="text"
              className={`input-currency input-currency-border ${!readOnly ? 'bg-white ' : ''}`}
              id="supervisorOffer"
              placeholder={t('ex_buyout_offer')}
              onChange={(e) => setBuyerOffer(e.target.value)}
              value={buyerOffer.replace('.', ',')}
              disabled={readOnly}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText className={`input-currency-border input-currency-label ${!readOnly ? 'bg-white ' : ''}`}>
                {currencySign()}
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          <Label for="buyerComment" className="text-secondary text-uppercase font-weight-light text-left">
            {t('comment')}
          </Label>

          <Input
            type="textarea"
            name="text"
            id="buyerComment"
            value={buyerComment}
            className={`input-currency-border input-currency-label ${!readOnly ? 'bg-white ' : ''}`}
            rows={2}
            onChange={(e) => setBuyerComment(e.target.value)}
            disabled={readOnly}
          />
        </Col>
      </Row>

      {!readOnly && (
        <Row>
          <Col className="text-center">
            <button
              type="button"
              className={`btn btn-block ${
                !((purchaseAllow === 'Y' && buyerOffer) || purchaseAllow === 'N') ||
                (enableCounterAppraisal && enableManualDecision && counterAppraisalAllow === '')
                  ? 'btn-4'
                  : 'btn-1'
              } mt-3`}
              onClick={handleCreate}
              disabled={
                !((purchaseAllow === 'Y' && buyerOffer) || purchaseAllow === 'N') ||
                (enableCounterAppraisal && enableManualDecision && counterAppraisalAllow === '')
              }
            >
              {isLoading && <Spinner size="sm" />}
              {t('sendToCommercial')}
            </button>
            {isError !== 'api_error_versions_quotation_unkown' && (
              <p className="ml-2 text-danger">
                <Translate code={isError} />
              </p>
            )}
            {message && <p className="text-left text-success">{message}</p>}
          </Col>
        </Row>
      )}
      {isNrmRecord && isNrmUser && (
        <button
          className="btn btn-2 btn-block px-2"
          type="button"
          onClick={() => history.push(`/files/${recordId}/garanteed-price`)}
        >
          <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">
            {t('requestGuaranteedPriceForNrmCta')}
          </span>
        </button>
      )}

      {permissionFord && coverage.showBtn && (
        <Row>
          <Col className="text-center">
            <button
              type="button"
              className={`btn btn-block ${!coverage.data ? 'btn-2' : 'btn-4'} mt-2`}
              onClick={toggle}
              disabled={!!coverage.data}
            >
              {t('requestGuaranteedPriceCta')}
            </button>
          </Col>
        </Row>
      )}

      {permissionFord && (
        <Row>
          <Col className="text-center">
            <button type="button" className="btn btn-3 btn-block px-2 mt-2" onClick={openAutobizTradeLink} tabIndex={0}>
              {t('accessAtModuleCta')}
            </button>
          </Col>
        </Row>
      )}
    </>
  );
};

Calculation.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  coverage: PropTypes.shape().isRequired,
  permissionFord: PropTypes.bool.isRequired,
  originId: PropTypes.number.isRequired,
};

export default Calculation;
